export const AUTH0_DOMAIN = window.APP_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = window.APP_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = window.APP_AUTH0_AUDIENCE;
